export const ALLOWED_MIME_TYPES = [
  'image/*',
  'video/mp4',
  'video/webm',
  'application/zip',
  'application/x-zip-compressed',
];

export const FALLBACK_EXTENSIONS = ['.zip'];
